import { useMutation, useQuery } from "@tanstack/react-query";
import { Button, Modal, Spin, message } from "antd";
import { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import { useState } from "react";
import { useIntl } from "react-intl";
import { editSVG, trashSVG } from "../../../assets/SVGs/SVGs";
import { deleteSuppliers, getSuppliers } from "../../../network/supplier";
import queryClient from "../../../services/react-query/queryClient";
import { queryKeys } from "../../../services/react-query/queryKeys";
import AntTable from "../../AntTable/AntTable";
import HeadTableServicesSuppliers from "../../GlobalTable/HeadTableServicesSuppliers";
import DeleteModal from "../../common/DeleteModal";
import ModalForm from "../../common/ModalForm";

type Props = {};

const Suppliers = (props: Props) => {
  const {
    data: Suppliers,
    isError,
    isLoading,
    isSuccess,
  } = useQuery([queryKeys.listSuppliers], () => getSuppliers());
  console.log(Suppliers);
  const intl = useIntl();
  const [selectedSupplierToDelete, setSelectedSupplierToDelete] = useState<
    number | null
  >(null);
  const [addStocktaking, setAddStocktaking] = useState(false);
  const [id, setId] = useState(0);
  const showModal = (id1: any = 0) => {
    setId(id1);
    setAddStocktaking(true);
  };
  const handleCancel = () => {
    setAddStocktaking(false);
  };
  const { mutate: DeleteSuppliers, isLoading: loadingDelete } = useMutation(
    (id) => deleteSuppliers(id),
    {
      onSuccess: (res: any) => {
        if (
          res?.response?.status === 422 ||
          res?.response?.status === 500 ||
          res?.response?.status === 404
        ) {
          message.error(res?.response?.data?.message);
        }
        queryClient.invalidateQueries([queryKeys.listSuppliers]);
        message.success("deleted");
      },
      onError: () => {
        message.error("try again");
      },
    }
  );
  const columns: ColumnsType<any> = [
    {
      title: (
        <div className="bg-[#eef0ff] w-full h-full  min-w-[100px]">
          {" "}
          {intl.formatMessage({ id: "supplierNameTitle" })}
        </div>
      ),
      dataIndex: "name",
      render: (text: any, record: any) => {
        return (
          <div className="bg-white !p-0 min-w-[150px] rounded-r-lg text-[#00086D] font-semibold">
            {record.name}
          </div>
        );
      },
    },
    {
      title: (
        <div className="bg-[#eef0ff] w-full h-full min-w-[100px]">
          {" "}
          {intl.formatMessage({ id: "mobileNumberTitle" })}
        </div>
      ),
      dataIndex: "branch",
      render: (text: any, record: any) => {
        return (
          <div dir="ltr" className="bg-white !p-0 min-w-[150px] text-[#75757E]">
            {record.phone}
          </div>
        );
      },
    },
    {
      title: (
        <div className="bg-[#eef0ff] w-full h-full min-w-[100px]">
          {" "}
          {intl.formatMessage({ id: "emailTitle" })}
        </div>
      ),
      dataIndex: "status",
      render: (text: any, record: any) => {
        return (
          <div className="bg-white !p-0 min-w-[150px] text-[#75757E] ">
            {record.email}
          </div>
        );
      },
    },
    {
      title: (
        <div className="bg-[#eef0ff] w-full h-full min-w-[100px]">
          {" "}
          {intl.formatMessage({ id: "updatedDateTitle" })}
        </div>
      ),
      dataIndex: "startDate",

      render: (text: any, record: any) => {
        return (
          <div className="bg-white !p-0 min-w-[150px] rounded-l-lg text-[#75757E] ">
            {dayjs(record?.updated_at).format("DD-MM-YYYY")}
          </div>
        );
      },
    },
    {
      title: <div className="bg-[#eef0ff] w-full h-full min-w-[100px]"></div>,
      dataIndex: "edit",
      render: (text: any, record: any) => {
        console.log(record);
        return (
          <div className="flex gap-2 !p-0">
            <Button
              type="text"
              htmlType="button"
              // className="bg-white py-3 min-w-[150px] rounded-r-lg text-[#00086D] font-semibold"
              onClick={() => showModal(record?.id)}
            >
              {editSVG}
            </Button>
            <Button
              type="text"
              htmlType="button"
              // className="bg-white py-3 min-w-[150px] rounded-r-lg text-[#00086D] font-semibold"
              onClick={() => setSelectedSupplierToDelete(record?.id)}
            >
              {trashSVG}
            </Button>
          </div>
        );
      },
    },
  ];
  return (
    <>
      <Modal
        width="50%"
        open={addStocktaking}
        onCancel={handleCancel}
        footer={null}
        className="max-md:min-w-[95%] max-lg:min-w-[80%]"
        destroyOnClose
      >
        <ModalForm close={handleCancel} isEdit={id} />
      </Modal>
      <DeleteModal
        visible={!!selectedSupplierToDelete}
        onClose={() => {
          setSelectedSupplierToDelete(null);
        }}
        onDelete={deleteSuppliers} // Pass the delete function for "Package"
        data={selectedSupplierToDelete}
        confirmationHeader={intl.formatMessage({
          id: "deleteSupplierConfirmation",
        })}
        confirmationText={""}
        // confirmationText={intl.formatMessage({
        //   id: "deleteSupplierConfirmationDesc",
        // })}
        queryKey={queryKeys.listSuppliers} // Pass the correct key here
        successMessage={intl.formatMessage({
          id: "supplierDeleted",
        })}
      />
      <div className=" bg-[#EEF0FF] px-6">
        <h4 className="px-6 pt-8 text-lg font-semibold">
          {intl.formatMessage({ id: "product_suppliers_title" })}
        </h4>
        <HeadTableServicesSuppliers />
        {isLoading ? (
          <Spin
            className="min-h-[50vh] bg-[#eef0ff] w-full flex items-center justify-center"
            size="large"
            spinning={isLoading}
          />
        ) : (
          <AntTable
            expandRowByClick={false}
            tableColumns={columns}
            tableData={Suppliers?.data || []}
            hideArrowExpand
            isLoading={isLoading}
          />
        )}
      </div>
    </>
  );
};

export default Suppliers;
